import { makeActionCreator } from '../../../utilities'
import { ServiceConstants } from './serviceSelection.constants'

export const setServicesList = makeActionCreator(ServiceConstants.SET_SERVICES_LIST, 'servicesList')
export const setIsLoading = makeActionCreator(ServiceConstants.SET_IS_LOADING, 'isLoading')
